/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import { TextField } from '@fluentui/react';
import React from 'react';

export default (props) => {
  const {
    editable = true,
    actualValue,
    validateValue,
    applyValue,
    onFocus,
    onBlur,
    fieldError,
    onFieldErrorClear,
  } = props;

  const [editableText, setEditableText] = React.useState(actualValue);
  const [editMode, setEditMode] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');

  const childProps = { ...props };
  childProps.value = actualValue;
  delete childProps.actualValue;
  delete childProps.deleteValue;
  delete childProps.applyValue;
  delete childProps.validateValue;
  delete childProps.fieldError;
  delete childProps.onFieldErrorClear;
  delete childProps.onFocus;
  delete childProps.onBlur;
  delete childProps.editable;

  const editableTextFieldRef = React.useRef();

  React.useEffect(() => {
    if (editable && editableTextFieldRef.current) {
      editableTextFieldRef.current.focus();
    }
  }, [editMode]);

  if (editable && editMode) {
    return (
      <TextField
        {...childProps}
        ref={editableTextFieldRef}
        placeholder={props.placeholder}
        value={editableText}
        onChange={(event, value) => {
          setErrorMessage('');
          if (onFieldErrorClear) {
            onFieldErrorClear();
          }
          setEditableText(value);
        }}
        onKeyDown={(event) => {
          if (event.keyCode === 13) {
            event.target.blur();
          } else if (event.keyCode === 27) {
            setEditMode(false);
            setErrorMessage('');
            setEditableText(actualValue);
          }
        }}
        onBlur={async () => {
          if (typeof onBlur === 'function') {
            onBlur();
          }
          let newValue;
          try {
            newValue = validateValue(editableText);
            await applyValue(newValue);
            setEditMode(false);
            setEditableText(newValue);
          } catch (error) {
            if (error instanceof Error) {
              setErrorMessage(error.message);
            } else if (typeof error === 'string') {
              setErrorMessage(error);
            } else {
              setErrorMessage('Invalid value');
            }
            if (editable && editableTextFieldRef.current) {
              editableTextFieldRef.current.focus();
            }
          }
        }}
        errorMessage={fieldError || errorMessage}
        styles={props.styles}
      />
    );
  }

  return (
    <TextField
      {...childProps}
      errorMessage={fieldError}
      readOnly
      onClick={editable ? () => {
        setEditableText(actualValue);
        setEditMode(true);
      } : undefined}
      onFocus={editable ? async () => {
        if (typeof onFocus === 'function') {
          onFocus();
        } else {
          setEditableText(actualValue);
          setEditMode(true);
        }
      } : undefined}
      styles={props.styles}
    />
  );
};
